<template>
  <data-table-list class="linked-resources-list-datatable" in-subpage>
    <!--FIXME VUE3: CURRENTLY NOT SUPPORTED
          mobile-breakpoint="0"
    -->
    <v-data-table-server
      v-model:page="options.page"
      v-model:sort-by="options.sortBy"
      :headers="headers"
      :items="resources"
      :items-per-page="options.itemsPerPage"
      :items-per-page-options="footerProps.itemsPerPageOptions"
      :show-current-page="footerProps.showCurrentPage"
      :loading="dataLoading"
      :items-length="totalResults"
      fixed-header
      mobile-breakpoint="0"
      item-value="uuid"
      @update:page="handlePageChanged"
      @update:options="handleSort"
    >
      <!-- Info -->
      <template #[`item.resourceTitle`]="{ item }">
        <data-table-cell
          class="info"
          :class="{ active: sortColumn === 'resourceTitle' && sortingActive }"
        >
          <svg-icon :name="getIconName" kind="indicative" />
          <!-- Title -->
          <div class="title">
            <span class="main">
              <ellipsis-text :text="item.resourceTitle" />
            </span>
            <cv-link v-if="showOpenLink(item)" @click="handleOpenLesson(item)">{{
              $t("open")
            }}</cv-link>
          </div>
        </data-table-cell>
      </template>

      <!-- Status -->
      <template #[`item.resourceStatus`]="{ item }">
        <data-table-cell
          class="status"
          :class="{ active: sortColumn === 'resourceStatus' && sortingActive }"
        >
          <span :title="item.resourceStatus" class="main">{{ item.resourceStatus }}</span>
        </data-table-cell>
      </template>

      <!-- Type -->
      <template #[`item.resourceType`]="{ item }">
        <data-table-cell
          class="type"
          :class="{ active: sortColumn === 'resourceType' && sortingActive }"
        >
          <span :title="item.resourceType" class="main">{{
            $t("search_resource_detail_linked_resource_course_type_label")
          }}</span>
        </data-table-cell>
      </template>

      <!-- Creator -->
      <template #[`item.creator`]="{ item }">
        <data-table-cell
          class="creator"
          :class="{ active: sortColumn === 'creator' && sortingActive }"
        >
          <span :title="item.resourceCreator" class="main">{{
            getColumnValue(item.resourceCreator)
          }}</span>
        </data-table-cell>
      </template>

      <!-- Owner Group -->
      <template #[`item.resourceOwnerGroup`]="{ item }">
        <data-table-cell
          class="owner-group"
          :class="{ active: sortColumn === 'resourceOwnerGroup' && sortingActive }"
        >
          <span :title="item.resourceOwnerGroup" class="main">{{
            getColumnValue(item.resourceOwnerGroup)
          }}</span>
        </data-table-cell>
      </template>
    </v-data-table-server>
  </data-table-list>
</template>

<script lang="ts">
import MediaObjectApi from "@apis/media.object.api";
import { isEmpty, isNull } from "@utils/var.check";
import { RESOURCE_STATUS } from "@modules/search/service/search.constant";
import { RESOURCE_DOMAIN_PATH } from "@plugins/common/constant/resource.constant";

export default {
  name: "LinkedResourcesTableList",
  props: {
    resourceUuid: { type: String, required: true },
  },
  data() {
    return {
      headers: [],
      footerProps: {},
      options: {},
      dataLoading: false,
      resources: [],
      sortColumn: "resourceTitle",
      sortDesc: false,
      totalResults: 0,
      itemsPerPage: 10,
      currentPage: 0,
    };
  },
  computed: {
    sortingActive() {
      return this.options.sortBy.length > 0;
    },
    getColumnValue() {
      return (item) => {
        return !isEmpty(item) ? item : "-";
      };
    },
    getIconName() {
      return "Lesson32";
    },
  },
  created() {
    this.initDataTable();
  },
  methods: {
    initDataTableOptions() {
      this.options = {
        page: 1,
        itemsPerPage: this.itemsPerPage,
        sortBy: [{ key: this.sortColumn, order: this.sortDesc ? "desc" : "asc" }],
      };
      this.footerProps = {
        itemsPerPageOptions: [], // Override to hide
        showCurrentPage: true,
      };
    },
    initDataTable() {
      this.dataLoading = true;
      this.initDataTableOptions();
      this.headers = [
        {
          title: this.$i18n.t("search_resource_detail_linked_resource_header_title"),
          class: "title",
          key: "resourceTitle",
        },
        {
          title: this.$i18n.t("search_resource_detail_linked_resource_header_status"),
          class: "status",
          key: "resourceStatus",
        },
        {
          title: this.$i18n.t("search_resource_detail_linked_resource_header_type"),
          class: "type",
          key: "resourceType",
        },
        {
          title: this.$i18n.t("search_resource_detail_linked_resource_header_creator"),
          class: "creator",
          key: "creator",
        },
        {
          title: this.$i18n.t("search_resource_detail_linked_resource_header_owner_group"),
          class: "owner-group",
          key: "resourceOwnerGroup",
        },
      ];
    },
    handleOpenLesson(item) {
      const resourceUuid = item.resourceUuid;
      const resourceStatus = item.resourceStatus;
      const belongToUserOwnerGroup = item.belongToUserOwnerGroup;

      const routeParams = {
        resourceDomain: RESOURCE_DOMAIN_PATH.MOE_LIBRARY,
        admin: "admin",
        mode: "view",
        lessonUuid: resourceUuid, //TODO [SLS-7201] do replace with moeLibraryUuid
      };

      // if user does not belong to owner group, only able to view approved version
      // if both approved/non-approved version of lesson exists, only approved version should show
      if (!belongToUserOwnerGroup || resourceStatus === "Approved") {
        routeParams.status = RESOURCE_STATUS.APPROVED.toLowerCase();
      }

      const routeData = this.$router.resolve({
        name: "EditorCover",
        params: routeParams,
        query: {
          version: resourceUuid,
        },
      });
      window.open(routeData.href, "_blank");
    },
    handlePageChanged(pageNumber) {
      if (this.currentPage === pageNumber) {
        return;
      }
      this.options.page = pageNumber;
      this.currentPage = pageNumber;
      this.start = (pageNumber - 1) * this.itemsPerPage;
      this.fetchLinkedResource();
    },
    handleSort(options) {
      if (options.sortBy.length > 0) {
        const currentSortColumn = this.sortColumn;
        const currentSortDirection = this.sortDesc;
        this.sortColumn = options.sortBy[0].key;
        this.sortDesc = options.sortBy[0].order === "desc" ? "descending" : "ascending";
        if (currentSortColumn === this.sortColumn && currentSortDirection === this.sortDesc) {
          return false;
        }
      } else {
        if (isNull(this.sortColumn) && isNull(this.sortDesc)) {
          return false;
        }
        this.sortColumn = null;
        this.sortDesc = null;
      }
      //return to first page
      this.options.page = 1;
      this.currentPage = 1;
      this.start = 0;
      this.fetchLinkedResource();
    },
    fetchLinkedResource() {
      this.dataLoading = true;
      MediaObjectApi.fetchMediaObjectLinkedResource({
        draw: 1,
        start: this.start,
        length: this.itemsPerPage,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDesc,
        uuid: this.resourceUuid,
      }).then((response) => {
        if (response.code === "ok") {
          this.resources = response.data.data;
          this.totalResults = response.data.recordsTotal;
          this.dataLoading = false;
        } else {
          this.dataLoading = false;
        }
      }, this.passiveApiFailHandler);
    },
    showOpenLink(item) {
      //able to open only if:
      //1. belong to user's owner groups OR must be approved version
      return item.belongToUserOwnerGroup || item.resourceStatus === "Approved";
    },
  },
};
</script>

<style lang="scss">
@import "@styles/abstracts/mixins";
@import "@styles/layout/breakpoint";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.linked-resources-list-datatable {
  .v-table {
    > .v-table__wrapper {
      > table {
        > thead {
          > tr {
            th {
              &.title {
                // Unset generic min-width for data table
                min-width: unset;
              }
            }
          }
        }

        .table-cell-wrapper {
          &.info {
            @include carbon--type-style("body-short-01", true);

            .sls-icon {
              margin-right: $spacing-03;
            }

            .title {
              display: flex;
              flex-flow: column nowrap;

              .main {
                display: inline-flex;

                > span {
                  @include media("desktop") {
                    @include line-clamp(2);
                    min-width: 10rem;
                  }
                }
              }

              .bx--link {
                @include carbon--type-style("button-02");
              }
            }
          }
        }
      }
    }
  }
}
</style>
